import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { QBuiltInspectorDialogService } from '../services/inspector-dialog.service';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { FacilityConfigService } from 'src/app/modules/facility-config/services/facility-config.service';
import { FacilityDataModel } from 'src/app/modules/facility-config/models/facility-config.model';

@Component({
    selector: 'open-defect-table',
    imports: [
    MatTableModule,
    MatIconModule,
    MatCheckbox,
    MatExpansionModule,
    MatProgressBarModule
],
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    templateUrl: './open-defect-table.component.html',
    styleUrl: './open-defect-table.component.scss'
})
export class OpenDefectTableComponent implements AfterViewInit {
  //session storage keys
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;

  @Input() dataSource: any[];
  @Input() station: any;
  @Output() emitDesignateDefect = new EventEmitter<any>();
  @Output() emitFixedDefect = new EventEmitter<any>();
  @Output() emitInZoneDefect = new EventEmitter<any>();
  isEmptyTable: boolean = false;
  openDefects: string = this.qbuiltInspConstants.openDefectColumn;
  designate: string = this.qbuiltInspConstants.designateColumn;
  fixed: string = this.qbuiltInspConstants.fixedColumn;
  sendToStationText: string = this.qbuiltInspConstants.SendToStationText;
  columnsToDisplay = [this.openDefects, this.designate, this.fixed];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandedElement: any | null;
  selectedTask: any;
  selectedLocation: any;
  locations: any[];
  facilityNumber: string = sessionStorage.getItem('facilityNumber') || '';
  stations: any[] = [];
  showText: boolean = false;

  stationIdList: any[] = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').stationIdList || [];
  
  constructor(private qbuiltInspConstants: QBuiltInspectorConstants,
    private qbuiltDialog: QBuiltInspectorDialogService, 
    private facilityConfigService: FacilityConfigService,
    private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
    let currentZone = JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId || 0;
    this.facilityConfigService.getConfigurationData(this.facilityNumber);
    let sub = this.facilityConfigService.facilityData$.subscribe((data: FacilityDataModel[]) => {
        if(data) {
          this.stations = []; // Clear before populating
            let possibleZones: any[] = [];
            data.forEach(zone => {
                if(zone.Id > currentZone) {
                    possibleZones.push(zone);
                }
            });
            possibleZones.forEach(zone => {
                if(zone.Stations) {
                    this.stations.push(...zone.Stations);
                }
            });
           this.stations = this.deduplicateStations(this.stations);
        }
    });

    if(this.dataSource.length === 0) {
      this.isEmptyTable = true;
    }
  
  }

  deduplicateStations(list: any[]): any[] {
  const map = new Map();
  list.forEach(station => {
    if (!map.has(station.Id)) {
      map.set(station.Id, station);
    }
  });
  return Array.from(map.values());
}


ngAfterViewInit() {
  const defectList = JSON.parse(sessionStorage.getItem(this.qbuiltInspConstants.defectItemsKey) || '{}').defectList || [];
  this.dataSource = defectList ? defectList : [];
  this.emptyTableCheck();
  this.cdRef.detectChanges();
}

  emptyTableCheck(): boolean {
    if(this.dataSource.length === 0) {
      this.isEmptyTable = true;
    } else {
      this.isEmptyTable = false;
    }
    return this.isEmptyTable;
  }

  populateLocations(LocationId?: number) {
    this.locations = localStorage.getItem('locations') ? JSON.parse(localStorage.getItem('locations')) : [];
    let locationName = this.locations.find(loc => loc.Id === LocationId);
    return locationName ? locationName.Name : '';
  }

  onCheckboxChange(event: any, element: any) {
    if(event.checked) {
      this.emitFixedDefect.emit(element);
    }
  }

  onExpandElement(element: any) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  //Opens modal to trigger send to station action
  sendToStation(element: any) {
    const dialogRef = this.qbuiltDialog.openInspectorDialog(5, this.stations);

    dialogRef.afterClosed().subscribe((result) => {
      if(result) {
        let stationId = result.Id;        
        this.emitDesignateDefect.emit({defect: element, stationResults: result});
      }
    });
  }
  
  //Shows if checkbox is checked and hide 'designate to station' button
  disabledCheck(element: any): boolean {
    let response;
    if(element.StatusId === 3 || this.stations.length === 0) {
      response = true;
    } else {
      response = false;
    }
    return response;
  }


  //returns whether or not the stations are equal
  stationEqual(element: any): boolean {
    let response
    if(this.station.Id === element.StationId) {
      response = true;
    } else {
      response = false;
    }
    return response;
  }

}
